import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/img/2fa_google-authenticator-3.svg'
import _imports_1 from '../../assets/img/2fa_microsoft-authenticator.svg'
import _imports_2 from '../../assets/img/2fa_authy.svg'
import _imports_3 from '../../assets/img/2fa_last_pass.png'
import _imports_4 from '../../assets/img/2fa_duo_mobile.png'


const _withScopeId = n => (_pushScopeId("data-v-a90de326"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "section--column--center" }
const _hoisted_2 = { class: "TwoFactorWizardstep-size-security data--center" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"flex__separate05\" data-v-a90de326><ul style=\"column-count:2;\" data-v-a90de326><li data-v-a90de326><img src=\"" + _imports_0 + "\" data-v-a90de326><span data-v-a90de326>Google Authenticator</span></li><li data-v-a90de326><img src=\"" + _imports_1 + "\" data-v-a90de326><span data-v-a90de326>Microsoft Authenticator</span></li><li data-v-a90de326><img src=\"" + _imports_2 + "\" data-v-a90de326><span data-v-a90de326>Authy</span></li><li data-v-a90de326><img src=\"" + _imports_3 + "\" data-v-a90de326><span data-v-a90de326>Last Pass</span></li><li data-v-a90de326><img src=\"" + _imports_4 + "\" data-v-a90de326><span data-v-a90de326>Duo Mobile</span></li></ul></div>", 1)
const _hoisted_4 = { class: "flex__separate05" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", null, [
        _createElementVNode("strong", null, _toDisplayString(_ctx.$t('TwoFactorAuth.AuthappQuestion')), 1)
      ]),
      _createElementVNode("p", null, _toDisplayString(_ctx.$t('TwoFactorAuth.AuthappDesc')), 1),
      _createElementVNode("p", null, [
        _createElementVNode("strong", null, _toDisplayString(_ctx.$t('TwoFactorAuth.AuthappRecomendApps')), 1)
      ]),
      _hoisted_3
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toBack && _ctx.toBack(...args))),
        class: "btn btn-primary p-x-2 border__rounded btn-2fa"
      }, _toDisplayString(_ctx.$t('wizard.previous')), 1),
      _createElementVNode("button", {
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toContinue && _ctx.toContinue(...args))),
        class: "btn btn-primary p-x-2 border__rounded btn-2fa"
      }, _toDisplayString(_ctx.$t('wizard.next')), 1)
    ])
  ]))
}